var INVALID_GPS_THRESHOLD = 9999

export { INVALID_GPS_THRESHOLD }

export default {
  data: function () {
    return {
      matching: false,
      INVALID_GPS_THRESHOLD: INVALID_GPS_THRESHOLD
    }
  },
  methods: {
    matchRow: function (joint) {
      var reportId = this.$store.getters.newReport.id
      if (!reportId) return
      var details = this.$store.getters.newReport.jointDetails || {}
      var d = details[joint.joint_id]
      var isUnmatched = !!joint._unmatched
      var isFieldMode = d && d._fromFieldMode
      if (!isUnmatched && !isFieldMode) return
      var vm = this
      var fieldWeldId = isUnmatched ? joint._fieldWeldId : (d._fieldWeldId || '')
      var rowId = isUnmatched ? joint._rowId : d._rowId
      var payload = { row_id: rowId, field_weld_id: fieldWeldId }
      vm.matching = true
      vm.$http.post('weldreport/' + reportId + '/match', payload).then(function (res) {
        vm.matching = false
        if (res.data.matched && res.data.matched.length > 0) {
          vm.$emit('reload-report')
        } else if (res.data.candidates && Object.keys(res.data.candidates).length > 0) {
          vm.$notify({
            group: 'full',
            type: 'warn',
            text: vm.$t('Multiple matches found')
          })
        } else {
          vm.$notify({
            group: 'full',
            type: 'warn',
            text: vm.$t('No matching joint found')
          })
        }
      }).catch(function (err) {
        vm.matching = false
        console.error('Match failed:', err)
        vm.$notify({ group: 'app', type: 'error', title: vm.$t('Error'), text: vm.$t('Match failed') })
      })
    },
    isFromFieldMode: function (joint) {
      if (joint._unmatched) return true
      var details = this.$store.getters.newReport.jointDetails || {}
      var d = details[joint.joint_id]
      return d && d._fromFieldMode
    },
    getFieldWeldId: function (joint) {
      if (joint._unmatched) return joint._fieldWeldId
      var details = this.$store.getters.newReport.jointDetails || {}
      var d = details[joint.joint_id]
      return (d && d._fieldWeldId) || ''
    },
    calcJointTime (val) {
      var min = Math.floor(val / 10)
      var sec = ((val / 10) - min).toFixed(2) * 10 * 6
      return min + ' ' + this.$t('TIME-min') + ' ' + sec + ' ' + this.$t('TIME-sec')
    },
    prepDataset (data) {
      return {
        max: Math.max(...data),
        labels: data.map(d => d[0]),
        datasets: [
          {
            label: 'Temperature over time',
            lineTension: 0,
            backgroundColor: 'rgba(255,255,255,0)',
            borderColor: '#63c2de',
            pointHoverBackgroundColor: '#fff',
            orderWidth: 2,
            data: data.map(d => d[1])
          }
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/JointMixin.js